export default __webpack_public_path__ + "static/media/social-youtube.c6f03fe0.svg";